import { createElement } from "react";
import { IconSvg, type IconSvgProps } from "@contra/icons/icons";
export const BorderlessAlertTriangleIcon = (props: IconSvgProps) =>
  createElement(
    IconSvg,
    {
      ...props,
      viewBox: "0 0 64 64",
    },
    <path
      fill="#F2C94C"
      d="M27.438 10.293 4.851 48a5.333 5.333 0 0 0 4.56 8h45.174a5.334 5.334 0 0 0 4.56-8L36.558 10.293a5.333 5.333 0 0 0-9.12 0"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4}
      d="M32 24v10.667"
    />,
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={5}
      d="M32 45.333h.027"
    />
  );
